import { useLocation, useNavigate } from 'react-router-dom'
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material'
import {
  HomeOutlined,
  AssignmentOutlined,
  CalendarMonthOutlined,
  EmojiEvents,
  PersonOutlined,
} from '@mui/icons-material'

export default function BottomNav() {
  const location = useLocation()
  const navigate = useNavigate()

  const routes = [
    { label: 'Dashboard', icon: <HomeOutlined />, path: '/' },
    { label: 'Tasks', icon: <AssignmentOutlined />, path: '/tasks' },
    { label: 'Calendar', icon: <CalendarMonthOutlined />, path: '/calendar' },
    { label: 'Rewards', icon: <EmojiEvents />, path: '/gamification' },
    { label: 'Profile', icon: <PersonOutlined />, path: '/settings' },
  ]

  const currentValue = routes.findIndex((route) => route.path === location.pathname)

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1100, // Higher z-index to stay above content
      }}
      elevation={3}
    >
      <BottomNavigation
        value={currentValue}
        onChange={(_, newValue) => {
          navigate(routes[newValue].path)
        }}
        showLabels
      >
        {routes.map((route) => (
          <BottomNavigationAction
            key={route.path}
            label={route.label}
            icon={route.icon}
          />
        ))}
      </BottomNavigation>
    </Paper>
  )
}
